export default Object.freeze({
  0: 'processApprovalEvaluation',
  1: 'delegation',
  2: 'delegationRestored',
  3: 'reassignedTask',
  4: 'selfAssignedTask',
});
